import React, { FC } from 'react';
import { useAuthenticationContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useTranslation } from '@aarhus-university/au-lib-react-components/src/lib/hooks';
import LoginComponent from './LoginComponent';
import { defaultLabels, importJson, TranslationsContext } from '../../lib/translation';

const LoginWrapperComponent: FC = () => {
  const authenticated = useAuthenticationContext();
  const lang = window.appLang;
  const translations = useTranslation<IMitStudieTranslation>(defaultLabels, [importJson('signin-menu', lang), importJson('generics', lang)], lang);
  if (authenticated) {
    return null;
  }

  return (
    <TranslationsContext.Provider value={translations}>
      <LoginComponent signInUrl="/MicrosoftIdentity/Account/SignIn" />
    </TranslationsContext.Provider>
  );
};

LoginWrapperComponent.displayName = 'LoginWrapperComponent';
export default LoginWrapperComponent;
